var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.55556C22 3.69645 21.2837 3 20.4 3H7.6C6.71635 3 6 3.69645 6 4.55556V5.5H16.4C18.072 5.5 19.5 6.82847 19.5 8.55556V16.3251C20.0845 16.5861 20.8327 16.809 21.8122 16.9969C21.9885 17.0307 22.0736 16.7802 21.9201 16.6855C20.7205 15.9453 20.1515 15.2125 20.0129 13.8889H20.4C21.2837 13.8889 22 13.1924 22 12.3333V4.55556Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.55556C2 7.69645 2.71634 7 3.6 7H16.4C17.2837 7 18 7.69645 18 8.55556V17.3333C18 18.1924 17.2837 18.8889 16.4 18.8889H6.75692C6.13047 20.3793 5.41406 21.3781 2.18783 21.9969C2.01147 22.0307 1.9264 21.7802 2.0799 21.6855C3.27948 20.9453 3.84846 20.2125 3.98707 18.8889H3.6C2.71634 18.8889 2 18.1924 2 17.3333V8.55556ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14ZM9 13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12C9.44772 12 9 12.4477 9 13ZM13 13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble19);
export default __webpack_public_path__ + "static/media/speech-bubble-19.5c1caba87aa141b91c6b2d140f0a0f92.svg";
export { ForwardRef as ReactComponent };